// @flow
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';
import styled from 'styled-components';
import colors from '../../../../ui/colors';

const propTypes = {
  date: PropTypes.instanceOf(moment),
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};

const defaultProps = {};

const StyledDay = styled.li`
  width: calc(100%/7);
  display: flex;
  position: relative;

  &:before {
    content: '';
    width: 100%;
    padding-top: 100%;
    position: relative;
    display: block;
  }

  & > button {
    background: transparent;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-top: 1px solid #DADADA;
    border-right: 1px solid #DADADA;
    box-sizing: border-box;
    display: inline-block;
    padding: 0;
    font-size: 0.8rem;
    font-family: inherit;
  }

  &.disabled > button {
    color: #C1C1C1;
    font-weight: normal;
  }

  &:not(.disabled) > button {
    cursor: pointer;
    &:hover {
      color: white;
      background-color: ${colors.GREEN_LIGHT};
    }


    .current-input-touch & {
      &:active {
        color: white;
      }
    }

    .current-input-mouse & {
      &:hover {
        color: white;
      }
    }
  }

  &.selected > button {
    color: #FFFFFF;
    background: ${colors.GREEN_DARK};
  }

  &.in-range > button {
    color: white;
  }

  &.in-hover-range > button {
    background: ${colors.GREEN_LIGHT};
    color: white;
  }

  &.blocked > button {
    color: black;
  }

  &:nth-child(7n) > button {
    border-right: 0;
  }
`;

const Day = ({date, disabled, selected, blocked, inRange, inHoverRange, onClick, addHoverClasses, onHover, onMouseLeave}: {date:moment, disabled:boolean, selected:boolean, blocked:boolean, inRange:boolean, inHoverRange:boolean, onClick:any, addHoverClasses:boolean, onHover:any}) => {
  const dayClass = classnames({
    'disabled': disabled,
    'selected': selected,
    'in-range': inRange && !selected,
    'in-hover-range': inHoverRange && !selected,
    'blocked': blocked,
  });
  return (
    <StyledDay className={dayClass}>
      {addHoverClasses ? (
        <button
          onClick={onClick}
          onMouseEnter={onHover}
          onMouseOver={onHover}
          disabled={disabled}
        >
          {date.date()}
        </button>
      ) : (
        <button
          onClick={onClick}
          disabled={disabled}
        >
          {date.date()}
        </button>
      )}
    </StyledDay>
  );
};

Day.propTypes = propTypes;
Day.defaultProps = defaultProps;

export default Day;


// WEBPACK FOOTER //
// ./src/modules/common/components/calendar/Day.js